<template>
  <div>
    <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      title="Add Comment"
      ref="addCommentModal"
      id="addCommentModal"
    >
      <div class="col-12 h-100">
        <div class="col-10 mb-4 d-flex input-material mx-auto">
          <input
            placeholder="Comment"
            type="text"
            v-model="comment"
            name="Comment"
            id="Comment"
            class="form-control"
          />
          <label>{{ "Enter Comment" }}</label>
          <VkeyboardFloat
            :ID="'Comment'"
            :onClickFun="() => {
              showVKeyboard = !showVKeyboard
            }"
          />
          <Vkeyboard
            :inputName="'Comment'"
            :showOrHide="showVKeyboard"
            :initialValue="comment"
            @onChangeEvent="() => {}"
            @onKeyEnter="onSaveDetails"
            @changeKeyboardInput="comment = $event"
            @onClickClose="() => {
              showVKeyboard = false;
            }"
          />
        </div>

        <div class="text-center mx-auto">
          <div class>
            <button
              @click="$bvModal.hide('addCommentModal')"
              class="btn-outline-blue-lg bg-transparent text-dark mr-1"
            >
              Cancel
            </button>
            <button
              v-if="getComment"
              v-on:click="onSaveDetails()"
              class="btn-blue-lg bg-blue text-white ml-1"
            >
              Update Comment
            </button>
            <button
              v-else
              v-on:click="onSaveDetails()"
              class="btn-blue-lg bg-blue text-white ml-1"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService.js";
import UserService from "@/services/UserService.js";
import PosService from "@/services/PosService.js";
import { mapState, mapGetters, mapActions } from "vuex";
import languages from "@/helper/Languages";
import i18n from "@/plugins/i18n";
import { BASEURL } from "@/config/index.js";
import Nav from "@/NavHybrid";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";

export default {
  props: {
    modalId: String
  },
  components: {
  VkeyboardFloat,
  Vkeyboard
  },
  data() {
    return {
      showVKeyboard:false,
      submitted: false,
      comment: ""
    };
  },
  computed: {
    getComment() {
      return this.$store.getters.getTransactionComment;
    },
    ...mapGetters([])
  },
  mounted() {},
  beforeMount() {
    this.comment = this.getComment || "";
  },
  methods: {
    ...mapActions(["AddComment"]),
    onSaveDetails() {
      this.AddComment(this.comment);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Partials/AddTransactionComment.vue